import Repository from './Repository'
const action = 'exporter/groups'

export default {
  postGroup(title) {
    return Repository.post(action, title)
  },
  getGroup() {
    return Repository.get(action)
  },
  getGroupContragents() {
    return Repository.get(action)
  },
  deleteContragents(id) {
    return Repository.delete(action + '/' + id, {
      id,
    })
  },
}
